var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "user")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBookPro-2017",
    transform: "translate(-64.000000, -261.000000)",
    stroke: "#C1C1C1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(65.000000, 262.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,16 C0,13.8039216 0.8125,12.4313725 2.4375,11.8823529 C4.875,11.0588235 4.875,10.2352941 4.875,9.41176471 C4.875,8.58823529 3.25,8.58823529 3.25,6.11764706 C3.25,3.64705882 4.0625,2 6.5,2 L6.71713693,2.00451444 C8.98599633,2.10057797 9.75,3.72192513 9.75,6.11764706 C9.75,8.58823529 8.125,8.58823529 8.125,9.41176471 C8.125,10.2352941 8.125,11.0588235 10.5625,11.8823529 C12.1875,12.4313725 13,13.8039216 13,16 L13,16 L0,16 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4545455,14 L8,14 C8,11.8039216 8.81818182,10.4313725 10.4545455,9.88235294 C12.9090909,9.05882353 12.9090909,8.23529412 12.9090909,7.41176471 C12.9090909,6.58823529 11.2727273,6.58823529 11.2727273,4.11764706 C11.2727273,1.64705882 12.0909091,0 14.5454545,0 C14.5454545,0 16.1818182,0 17,0.823529412",
    id: "Path-4",
    strokeLinecap: "round",
    transform: "translate(12.500000, 7.000000) scale(-1, 1) translate(-12.500000, -7.000000) "
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.b846dd8a.svg";
export { ForwardRef as ReactComponent };